import React, { useEffect, useRef, useState } from "react";
import { Icon } from "@iconify/react";
import { motion as m, useAnimation, useInView } from "framer-motion";

const Accordion = ({ data }) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const mainControls = useAnimation();

  useEffect(() => {
    if (isInView) {
      mainControls.start("visible");
    }
  }, [isInView]);
  return (
    <m.div
      className="flex flex-col w-full rounded-lg bg-[#F2F2F2] shadow-md"
      ref={ref}
      variants={{
        hidden: { opacity: 0, y: -20 },
        visible: { opacity: 1, y: 0 },
      }}
      initial="hidden"
      animate={mainControls}
      transition={{ duration: 1 }}
    >
      <div
        className="flex p-6 items-center justify-between"
        onClick={() => setIsOpen(!isOpen)}
      >
        <h2 className="text-[20px]">{data.name}</h2>
        <Icon
          icon="tabler:chevron-down"
          className={`size-6 transition-all ease-in-out duration-500 ${
            isOpen && "rotate-180"
          }`}
        />
      </div>
      <div
        className={`grid grid-cols-2 lg:grid-cols-4 px-6 gap-16 transition-all ease-in-out duration-500 overflow-hidden ${
          isOpen ? "max-h-100 py-6" : "max-h-0 py-0"
        }`}
      >
        {data.brands.map((brand, index) => (
          <div key={index + 1}>
            {brand.link !== "" ? (
              <a
                className="flex flex-col h-full items-center justify-center gap-2 rounded-lg shadow-md hover:shadow-xl cursor-pointer p-4"
                href={brand.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="flex w-full h-full items-center">
                  <img src={brand.image} alt={brand.name} />
                </div>
                <p className="text-center">{brand.name}</p>
              </a>
            ) : (
              <div className="flex flex-col h-full items-center justify-center gap-2 rounded-lg p-4">
                <div className="flex w-full h-full items-center">
                  <img src={brand.image} alt={brand.name} />
                </div>
                <p className="text-center">{brand.name}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </m.div>
  );
};

export default Accordion;
